import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/hero-2-element-3.svg")